import { ActionType } from '@/graphql'

// Themes
export const THEMES = {
  DEFAULT: 'DEFAULT',
  DARK: 'DARK',
  LIGHT: 'LIGHT',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  INDIGO: 'INDIGO',
}

export const COMMON_TASK_TYPES = [
  ActionType.PICTURE,
  ActionType.SIMPLE,
  ActionType.COMPLIANCE_CHECK,
]

export const getStatColumns = (t: (key: string) => string) => {
  return {
    TOTAL_REVENUE: t('statColumns.totalRevenue'),
    AVG_STORE_REVENUE: t('statColumns.avgStoreRevenue'),
    INSIDE_SALES: t('statColumns.insideSales'),
    COMPLIANCE: t('statColumns.compliance'),
    EMPTY_FACINGS: t('statColumns.emptyFacings'),
    RESTOCK_COMPLETION: t('statColumns.restockCompletion'),
    TASK_COMPLETION: t('statColumns.taskCompletion'),
  }
}

export const getProductStatColumns = (t: (key: string) => string) => {
  return {
    TOTAL_REVENUE: t('statColumns.totalRevenue'),
    TOTAL_EARNINGS: t('statColumns.totalMargin'),
    VOLUME: t('statColumns.volume'),
    FACINGS: t('statColumns.facings'),
    EMPTY_FACINGS: t('statColumns.emptyFacings'),
    REVENUE_PER_FACING: t('statColumns.revenuePerFacing'),
    EARNINGS_PER_FACING: t('statColumns.marginPerFacing'),
  }
}

export const getRevenueDetailsStatColumns = (t: (key: string) => string) => {
  return {
    TOTAL_REVENUE: t('statColumns.totalRevenue'),
    INSIDE_SALES: t('statColumns.insideSales'),
    OUTSIDE_SALES: t('statColumns.outsideSales'),
    FUEL_VOLUME: t('statColumns.fuelVolume'),
  }
}

export const DEFAULT_AVATAR = '/static/img/avatargs/default.jpg'

// Default threshold below which data coverage triggers warning banner
export const DEFAULT_DATA_COVERAGE_THRESHOLD = 75

// Default number of days to look back when suggesting a new date range from the warning banner
export const DEFAULT_DAYS_LOOKBACK = 30

// Threshold above which percentage changes are hidden on stat cards (likely low data in before period)
export const PERCENT_CHANGE_THRESHOLD = 300
